"use strict";
/**
 * This is to load non run-time / async federated apps.
 * @param remoteNames
 * @param nodeEnv
 * @returns
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.attachFederatedAppsFromManifest = void 0;
const manifest_domains_1 = __importDefault(require("./manifest-domains"));
const attachFederatedAppsFromManifest = (remoteNames, nodeEnv, manifestURL) => {
    const _manifestURL = (0, manifest_domains_1.default)(nodeEnv, manifestURL);
    return Object.fromEntries(remoteNames.map(name => [
        name,
        `promise new Promise(async (resolve, reject) => {
          if (typeof window === 'undefined') return reject(new Error('window is not defined'));
          
          // Check if manifest is already available with federatedApps
          if (!window.__APP_MANIFEST__?.federatedApps) {
            // Try to fetch latest manifest first
            let appManifest = fetch("${_manifestURL?.latest}").then(res => {
              return res.json();
            }).catch(async err => {
              console.error("Failed to fetch latest manifest: ", err);
              
              // If latest fails and fallback exists, try fallback
              if ("${_manifestURL?.fallback}") {
                console.log("Attempting to fetch fallback manifest...");
                const fallbackRes = await fetch("${_manifestURL?.fallback}");
                if (!fallbackRes.ok) throw new Error('Failed to fetch fallback manifest');
                return fallbackRes.json();
              }
              return {}; // fallback is object
            });
            window.__APP_MANIFEST__ = await appManifest;
          }

          const manifest = await window.__APP_MANIFEST__.federatedApps;
          const url = manifest["${name}"];
          if (!url) return reject(new Error("Remote not found: ${name}"));
  
          const script = document.createElement('script');
          script.src = url;
          script.onload = () => {
            const proxy = {
              get: (request) => window["${name}"].get(request),
              init: (arg) => {
                try { return window["${name}"].init(arg); } catch (_) {}
              }
            };
            resolve(proxy);
          };
          script.onerror = () => reject(new Error("Failed to load remote: " + url));
          document.head.appendChild(script);
        })`,
    ]));
};
exports.attachFederatedAppsFromManifest = attachFederatedAppsFromManifest;
//# sourceMappingURL=attach-federated-apps-from-manifest.js.map